<template>
  <v-card>
    <v-toolbar flat dark color="success">
      <v-spacer/>
      <v-toolbar-title>{{ editMode ? "Edit USSD Poll" : "Add USSD Poll" }}</v-toolbar-title>
      <v-spacer/>
    </v-toolbar>
    <v-card-text>
      <v-form class="mt-3" v-if="!loading">
        <v-autocomplete dense small-chips chips deletable-chips outlined label="Level to get Survey"
                        v-model="smsCampaignForm.level"
                        :items="levels" item-text="name" item-value="value"/>
        <v-autocomplete return-object v-if="smsCampaignForm.level" dense chips deletable-chips outlined label="County"
                        :items="counties" item-text="county" item-value="county" @change="getConstituency"/>
        <v-autocomplete v-if="checkLevel('constituency')" dense chips deletable-chips outlined label="Constituency"
                        :items="constituencies" item-text="constituency" item-value="value" return-object
                        @change="getWard"/>
        <v-autocomplete v-if="checkLevel('ward')" dense chips deletable-chips return-object outlined label="Ward"
                        :items="wards" item-text="ward" item-value="value" @change="getPollingStation"/>
        <v-autocomplete v-if="checkLevel('polling')" dense chips deletable-chips outlined label="Polling Station"
                        v-model="smsCampaignForm.pollingstation"
                        :items="pollingstations" item-text="pollingstation" item-value="value"/>
        <v-row v-for="(line,i) in smsCampaignForm.data" :key="i">
          <v-col cols="12" md="10" class="pa-2">
            <v-text-field
                outlined dense
                v-model="line.question"
                label="Poll Question"
                required
            />
          </v-col>
          <v-col cols="12" md="2" class="pa-2">
            <v-btn fab small color="error" @click="removeLine(i)">
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
          </v-col>
          <v-col col="12" md="12">
            <v-row v-for="(answer,k) in line.answers" :key="k">
              <v-col cols="12" md="8" class="">
                <v-text-field
                    outlined dense
                    v-model="answer.answer"
                    label="Answer"
                    required
                />
              </v-col>
<!--              <v-col cols="12" md="4" class="">-->
<!--                <v-file-input-->
<!--                    outlined-->
<!--                    dense-->
<!--                    accept="image/*"-->
<!--                    label="Upload your passport sized photo"-->
<!--                    @change="onPassportSelected(answer,$event)"-->
<!--                ></v-file-input>-->
<!--              </v-col>-->
              <v-col cols="12" md="2" class="pa-2">
                <v-btn fab small color="error" @click="removeALine(k,i)">
                  <v-icon dark>mdi-minus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-btn small fab color="blue" @click="addLineAnswer(i)">
                  <v-icon dark x-small>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn small fab color="success" @click="addLine">
              <v-icon dark small>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="editMode?UpdateClientAdmin():RegisterClientAdmin()"
               :color="editMode?'blue':'green'" dark>
          {{ editMode ? 'Edit USSD Campaign' : 'Create USSD Campaign' }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import {getRequest, postRequest} from "@/api/apirepository";

export default {
  name: "ussdCampaignForm",
  props: {
    selectedClientAdmin: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      blockRemoval: true,
      wards: [],
      counties: [],
      constituencies: [],
      pollingstations: [],
      levels: [
        {name: 'County', value: 'county'},
        {name: 'Constituency', value: 'constituency'},
        {name: 'Ward', value: 'ward'},
        {name: 'Polling Station', value: 'pollingstation'},
      ],
      smsCampaignForm: new Form({
        id: "",
        county: "",
        constituency: "",
        ward: "",
        pollingstation: "",
        level: "",
        message: "",
        data: [],
        userId: this.$store.state.user.id,
      }),
    }
  },
  computed: {
    editMode: {
      get: function () {
        return !!this.selectedClientAdmin;
      },
      set: function (newValue) {
        return !!this.selectedClientAdmin;
      }
    },
  },
  mounted() {
    if (this.selectedClientAdmin) {
      this.editMode = true;
      this.smsCampaignForm.fill(this.selectedClientAdmin);
    } else {
      this.addLine()
    }
  },
  methods: {
    addLine() {
      let checkEmptyLines = this.smsCampaignForm.data.filter(line => line.question === null);

      if (checkEmptyLines.length >= 1 && this.smsCampaignForm.data.length > 0) {
        this.dialog = true;
        return;
      }

      this.smsCampaignForm.data.push({
        question: null,
        answers: []
      })
    },
    addLineAnswer(index) {
      // let checkEmptyLines = this.smsCampaignForm.data.filter(line => line.answers === null);
      //
      // if (checkEmptyLines.length >= 1 && this.smsCampaignForm.data.length > 0) {
      //   this.dialog = true;
      //   return;
      // }

      this.smsCampaignForm.data[index].answers.push({
        answer: ""
      })
    },

    removeLine(lineId) {
      console.log(lineId)
      if (this.blockRemoval) this.smsCampaignForm.data.splice(lineId, 1)
    },
    removeALine(lineId,answerId) {
      if (this.blockRemoval) this.smsCampaignForm.data[answerId].answers.splice(lineId, 1)
    },
    getCounties() {
      postRequest('counties').then(({data}) => {
        this.counties = data;
      }).catch(e => {
        console.log(e)
      })
    },
    checkLevel(e) {
      if (e === 'constituency') {
        if (this.smsCampaignForm.level === 'county') {
          return false;
        } else if (this.smsCampaignForm.level === 'constituency' || this.smsCampaignForm.level === 'ward' || this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      } else if (e === 'ward') {
        if (this.smsCampaignForm.level === 'county' || this.smsCampaignForm.level === 'constituency') {
          return false;
        } else if (this.smsCampaignForm.level === 'ward' || this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      } else if (e === 'polling') {
        if (this.smsCampaignForm.level === 'county' || this.smsCampaignForm.level === 'constituency' || this.smsCampaignForm.level === 'ward') {
          return false;
        } else if (this.smsCampaignForm.level === 'pollingstation') {
          return true;
        }
      }
    },
    getConstituency(e) {
      this.smsCampaignForm.county = e.county;
      if (this.checkLevel('constituency')) {
        postRequest('constituencies', {
          county: e.county
        }).then(({data}) => {
          this.constituencies = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getWard(e) {
      this.smsCampaignForm.constituency = e.constituency;
      if (this.checkLevel('ward')) {
        postRequest('wards', {
              constituency: e.constituency,
              county: e.county,
            }
        ).then(({data}) => {
          this.wards = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    getPollingStation(e) {
      this.smsCampaignForm.ward = e.ward;
      if (this.checkLevel('polling')) {
        postRequest('pollingstations', {

          ward: e.ward

        }).then(({data}) => {
          this.pollingstations = data;
        }).catch(e => {
          console.log(e)
        })
      }
    },
    RegisterClientAdmin() {
      postRequest('ussdPoll', this.smsCampaignForm).then(e => {
        this.$emit('campaignSuccess')
      }).catch(e => {
        swal.fire('error', 'Something went wrong', 'error')
      })
    }
  },
  created() {
    this.getCounties()
  }
}
</script>

<style scoped>

</style>